export const defaultH2Style = {
    fontSize: "13px",
    marginBottom: "0px",
    fontWeight: "normal"
};

export const defaultContainerStyle = {
    boxSizing: "border-box"
};

export const defaultContentColumnStyle = {
    display: "inline-block",
    verticalAlign: "top"
};

export const defaultKeyStyle = {
    paddingTop: "0px",
    paddingBottom: "0px",
    textAlign: "left",
    fontWeight: "normal"
};

export const defaultAdaptiveKeyStyle = {
    paddingTop: "0px",
    paddingBottom: "0px",
    textAlign: "left",
    fontWeight: "normal"
};

export const defaultValueStyle = {
    paddingTop: "0px",
    paddingBottom: "0px",
    textAlign: "right",
    fontWeight: "normal"
};

export const defaultShapeStyle = {
    lineHeight: "normal",
    boxSizing: "border-box"
};
//# sourceMappingURL=style-constants.js.map
